import { GridRow } from 'src/components/Reusable/Grid'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const DocumentRow = styled(GridRow)<{ $disabled?: boolean }>`
  padding: 0.5rem 0;
  border-bottom: 1px solid ${palette.neutral['30']};
  cursor: pointer;
  ${({ $disabled }) =>
    $disabled &&
    `
    background-color: ${palette.neutral['100']};
    cursor: default;
    &:hover {
      .grid-column {
        background-color: ${palette.neutral['100']};
      }
    }
    .grid-column {
      background-color: ${palette.neutral['100']};
      pointer-events: none;
      
      button {
        pointer-events: auto;
      }
    }
  `}
  &:hover {
    .grid-column {
      background-color: ${palette.neutral['50']};
    }
  }
`
